import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterService} from '../../filters/service/filter.service';
import {ToastrService} from 'ngx-toastr';
import {AlgorithmConfigService} from '../service/algorithm-config.service';
import {first} from 'rxjs/operators';
import {CampaignService} from '../../campaign/service/campaign.service';

@Component({
  selector: 'app-algorithm-config-form',
  templateUrl: './algorithm-config-form.component.html',
  styleUrls: ['./algorithm-config-form.component.css']
})
export class AlgorithmConfigFormComponent implements OnInit {
  algoId: any;
  isEdit = false;
  algoDetailForm: FormGroup;
  algoTypeList: any = [];
  loading: boolean;
  submitted: boolean;
  algoValueMap = new Map();
  campaign: any;
  campaignNumber: any;
  constructor(private _formBuilder: FormBuilder,
              private router: Router,
              private algorithmConfigService: AlgorithmConfigService,
              private campaignService: CampaignService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {

    this.route.fragment.subscribe(fragment => { this.algoId = fragment; });
    if (this.algoId) {
      this.isEdit = true;
      this.getAlgoDetails(this.algoId);
    }

    this.algoDetailForm = this._formBuilder.group({
      id: [''],
      type: ['', Validators.required],
      campaignId : ['', Validators.required],
      config: [{}, Validators.required]
    });
  }

  ngOnInit() {
    this.getAlgoTypes();
  }

  getAlgoDetails(algoId) {
    this.algorithmConfigService.getAlgoById(algoId)
        .subscribe(data => {
          const response: any = data.json();
          this.algoDetailForm.controls['id'].setValue( response.id);
          this.algoDetailForm.controls['type'].setValue( response.type);
          this.algoDetailForm.controls['campaignId'].setValue( response.campaignId);
          this.algoDetailForm.controls['config'].setValue( response.config);
          this.algoValueMap = this.algoDetailForm.controls['config'].value;
          console.log(this.algoDetailForm.value);
          this.campaignService.getCampaignsDetails(response.campaignId).subscribe(campaignData => {
              this.campaign  = campaignData.json();
              this.campaignNumber = this.campaign.campaignNumber;
          });
            console.log(this.campaign);

            this.loading = false;
        }, (error) => {
          this.loading = false;
        });
  }

  getAlgoTypes() {
    this.algorithmConfigService.getAllAlgos()
        .subscribe(data => {
          const response: any = data.json();
          this.algoTypeList = response;
          console.log(this.algoTypeList);
          this.loading = false;
        }, (error) => {
          this.loading = false;
        });
  }

  saveAlgo(algo) {
    console.log(algo);
    this.algorithmConfigService.updateAlgo(algo.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Algorithm Updated successfully');
            this.router.navigate(['/elasticcare/algorithm']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }

  onChange(filterKey, eventActualValue) {
    this.algoValueMap[filterKey] = eventActualValue;
    console.log(this.algoValueMap);
    /*    console.log(filterKey);
        console.log(index);
        console.log(eventActualValue);*/
  }
}
